module.exports = function(h, row) {
    if (_.isNull(row.tags) || row.tags == '') {
        return <i class="text-muted">No tags assigned</i>;
    }

    const tags = row.tags.split(',');

    if (tags.length < 1) {
        return <i class="text-muted">No tags assigned</i>;
    }

    if (tags.length === 1) {
        return tags[0];
    }

    return <i>Assigned to {tags.length} tags</i>;
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/item/vuetableitem_tags.jsx